import BaseService from "./BaseService";

export default class ReferralService extends BaseService {

    public static getAllAvilableRulesWithCommonData(token: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}referralcode/get-referral-code-rules`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
        })
    }

    public static updateAndSaveSettings(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}referralcode/update-referral-code-rule`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getCorridorList(token: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}referralcode/get-corridor-country-list`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
        })
    }

    public static getRulesByCorridorCurrency(token: string, currency: string, countryId: string) {
        return BaseService.sendRequest(
            `${process.env.REACT_APP_API_URL}referralcode/get-corridor-currency-pair-list/${currency}/${countryId}`,
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
            }
        );
    }

    public static createRules(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}referralcode/add-referral-code-rule`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getReferralList(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}referralcode/get-referral-details`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getRefereeList(token: string, postData: any, _id: string) {
        const url = `${process.env.REACT_APP_API_URL}referralcode/get-referee-list/${_id}`;

        return BaseService.sendRequest(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static getInvitedUsersList(token: string, postData: any, _id: string) {
        const url = `${process.env.REACT_APP_API_URL}referralcode/get-referral-invite-list/${_id}`;

        return BaseService.sendRequest(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

}